(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:CountriesService
     *
     * @description
     *
     */
    angular
        .module('payments')
        .factory('CountriesService', CountriesService);

    function CountriesService(EndpointsService, $q, $http, $log) {
        var CountriesServiceBase = {};
        CountriesServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                //$log.debug("Params:", params);
                $http.get(response.links.countries, {
                        params: params
                    })
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        };

        CountriesServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.countries_id.replace('{id}', id))
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        };
        return CountriesServiceBase;
    }
}());
